import React, {Component} from 'react';

class Service extends Component {

  changeSelected = (event) => {
    const {id, onClick, urlService} = this.props;
    onClick(id, urlService, event.target.checked)
  }

  render() {
    const {
      id,
      label,
      selected,
    } = this.props;

    return (
    <div className="radiobutton-row center">
      <input type="checkbox" id={id} name={label} value={label} checked={selected} onChange={this.changeSelected}/>
      <label htmlFor={id}>{label}</label>
    </div>);
  }
}

export default Service;
